var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"multiple-list-text-answer"},[(Array.isArray(_vm.currentAnswer) && _vm.question !== null)?_c('div',[_c('span',[_vm._v(_vm._s(_vm.answerData))])]):_c('div',[_vm._v(_vm._s(_vm.answerData))])])}
var staticRenderFns = []

export { render, staticRenderFns }